<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 slot="title" class="mb-0">
          Información de la proyección
          <badge v-if="projection.state" class="mb-0 float-right" :type="projection.state.color">
            {{ projection.state.label }}
          </badge>
          <badge v-else class="mb-0 float-right" type="primary"> Sin Seguimiento </badge>
        </h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Productor</p>
            <router-link
              v-if="$can('show', 'producers')"
              :to="{ name: 'ProducerShow', params: { id: projection.producer.id } }"
            >
              {{ projection.producer.businessName }}
            </router-link>
            <p v-else>{{ projection.producer.businessName }}</p>
          </div>

          <div class="col-sm-3 col-xs-12">
            <p class="h5 mb-0">Campaña</p>
            <p>{{ projection.variety.crop.name }} {{ projection.campaign.name }}</p>
          </div>

          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Mes</p>
            <p>{{ projection.period }}</p>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Variedad</p>
            <p>{{ projection.variety.name }}</p>
          </div>

          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Cantidad Inicial</p>
            <p>{{ projection.defaultQuantity }}</p>
          </div>

          <div v-if="projection.lastActivityDate" class="col-sm-6 col-xs-12">
            <p class="h5 mb-0">Cantidad Actual</p>
            <p>{{ projection.quantity }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Variedad Competidor</p>
            <p>
              <span v-if="projection.competitorVariety">{{ projection.competitorVariety }}</span>
              <span v-else class="font-italic">No especificada </span>
            </p>
          </div>

          <div class="col-sm-3 col-xs-12 text-center text-sm-left">
            <p class="h5 mb-0">Cantidad Competidor</p>
            <p>
              <span v-if="projection.competitorQuantity">{{ projection.competitorQuantity }}</span>
              <span v-else class="font-italic">No especificada </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectionData',
  props: {
    projection: null,
  },
};
</script>
